<template>
    <v-card
            class="pa-6 grey lighten-5 mt-3" 
            width="500"
            flat
        >
        <v-row
            align="center"
            justify="end"
        >  
            <v-btn 
                @click="navigatePrevious" 
                v-show="!isFirst()"
                :color="buttonColor"
                outlined
            >
                Previous
            </v-btn>
            <v-btn 
                @click="navigateNext"
                :color="buttonColor"
                dark
                class="ml-6"
            > 
                {{ nextButtonText() }}
            </v-btn>
        </v-row>
    </v-card>    
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'

export default {
    computed: {
        ...mapGetters({
            primary: 'form/getPrimaryColor',
            darken: 'form/getColorDarken',
            studentDataFields: 'form/getStudentDataFields',
            familyOptions: 'form/getFamilyDataFields',
            otherFields: 'form/getFamilyDemographicFields',
            otherDataFields: 'form/getOtherDataFields',
            studentRecord: 'auth/getStudentRecord',
            formProgress: 'form/getFormProgress',
            termsAndConditions: 'form/getTermsAndConditions',
        }),
        buttonColor(){
            return this.primary + ' ' + this.darken;
        }
    },
    methods: {
        ...mapMutations({
            setCurrentStep: 'form/setCurrentStep',
            setDialog: 'form/setDialog',
            setDialogTitle: 'form/setDialogTitle',
            setDialogText: 'form/setDialogText',
            setDialogTextColor: 'form/setDialogTextColor',
            setDialogCard: 'form/setDialogCard',
            setDialogProgress: 'form/setDialogProgress',
            setValidationErrors: 'form/setValidationErrors',
            setStudentDataValidated: 'form/setStudentDataValidated',
            setFamilyDataValidated: 'form/setFamilyDataValidated',
            setOtherDataValidated: 'form/setOtherDataValidated',
            setFormProgress: 'form/setFormProgress',
            setDialogSuccessIcon: 'form/setDialogSuccessIcon',
            setDialogWarningIcon: 'form/setDialogWarningIcon',
        }),
        ...mapGetters({
            getStudentDataValidated: 'form/getStudentDataValidated',
            getFamilyDataValidated: 'form/getFamilyDataValidated',
            getOtherDataValidated: 'form/getOtherDataValidated',
        }),
        nextButtonText(){
            if(
                this.$route.name === 'complete'                
            ){               
                return 'Finish';
            }
            return 'Next';
        },

        isFirst(){
            return this.$route.name === 'studentData';
        },

        navigateNext(){
            //console.log(this.$route.name);
            switch(this.$route.name){                
                case 'documents':
                    this.setCurrentStep(6);
                    this.$router.push('/registration/complete');                    
                    break;
                case 'otherData':
                    this.validateOtherData();
                    this.checkSectionValidation('OtherData');
                    break;
                case 'healthData':
                    this.setCurrentStep(4);
                    this.$router.push('/registration/other-data');
                    break;
                case 'familyData':                    
                    this.validateFamilyData();                    
                    this.checkSectionValidation('FamilyData');
                    break;                    
                case 'studentData':
                    this.validateStudentData();                    
                    this.checkSectionValidation('StudentData');
                    break;
                case 'complete':
                    if(this.termsAndConditions){
                        this.setDialogTitle('Form Completed');
                        this.setDialogText('Thank you for submitting your registration form.');
                        this.setDialogTextColor('indigo--text text--darken-4');
                        this.setDialogSuccessIcon(true);
                        this.setDialogWarningIcon(false);
                    }
                    else{
                        this.setDialogTitle('Terms and Conditions');
                        this.setDialogText('Before submitting you must accept the terms and conditions.');
                        this.setDialogTextColor('red--text text--darken-4');
                        this.setDialogWarningIcon(true);
                        this.setDialogSuccessIcon(false);
                    }
                    this.setDialog(true);                    
                    this.setDialogCard(true);
                    this.setDialogProgress(false);                    
                    break;

            }
            document.documentElement.scrollTop = 0;
        },

        navigatePrevious(){
            //console.log(this.$route.name);
            switch(this.$route.name){
                case 'complete':
                    this.setCurrentStep(5);
                    this.$router.push('/registration/documents');
                    break;
                case 'documents':
                    this.setCurrentStep(4);
                    this.$router.push('/registration/other-data');
                    break;
                case 'otherData':
                    this.setCurrentStep(3);
                    this.$router.push('/registration/health-data');
                    break;
                case 'healthData':
                    this.setCurrentStep(2);
                    this.$router.push('/registration/family-data');
                    break;
                case 'familyData':
                    this.setCurrentStep(1);
                    this.$router.push('/registration/student-data');
                    break;                                       
            }
            document.documentElement.scrollTop = 0;
        },

        checkSectionValidation(section){
            switch(section){
                case 'StudentData':
                    if(this.getStudentDataValidated()){
                        let progress = {...this.formProgress};
                        progress.studentData = true;
                        this.setFormProgress(progress);                        
                        this.setCurrentStep(2);
                        this.$router.push('/registration/family-data');
                    }
                    else{                        
                        this.displayValidationErrors()
                    }
                    break;
                case 'FamilyData':
                    if(this.getFamilyDataValidated()){                        
                        let progress = {...this.formProgress};
                        progress.familyData = true;
                        this.setFormProgress(progress);                       
                        this.setCurrentStep(3);
                        this.$router.push('/registration/health-data');
                    }
                    else{                        
                        this.displayValidationErrors()
                    }
                    break;
                case 'OtherData':
                    if(this.getOtherDataValidated()){                        
                        let progress = {...this.formProgress};
                        progress.otherData = true;
                        this.setFormProgress(progress);                       
                        this.setCurrentStep(5);
                        this.$router.push('/registration/documents');
                    }
                    else{                        
                        this.displayValidationErrors()
                    }
                    break;
            }
        },

        validateStudentData(){            
            let validationErrors = [];
            let formHasErrors = false;
            
            this.studentDataFields.forEach(element => {
                if(element.required && !this.studentRecord[element.model]) {                    
                    console.log(`${element.model} : false`);
                    formHasErrors = true;
                    validationErrors.push(`${element.label} is required.`);
                }
                
                if(!formHasErrors) this.setStudentDataValidated(true);
                else this.setStudentDataValidated(false);
            })

            this.setValidationErrors(validationErrors);            
        },
        
        validateFamilyData(){
            let validationErrors = [];
            let formHasErrors = false;
            let atLeastOneParentVisible = false;
            
            console.log(`Family Data Validated: ${this.getFamilyDataValidated()}`);
            //console.log(this.familyOptions);
            
            this.familyOptions.forEach(familyOption => {                
                if(familyOption.visible){
                    atLeastOneParentVisible = true;                    
                    familyOption.fields.forEach(field => {
                        if(field.required && !this.studentRecord[field.model]) {                    
                            console.log(`${familyOption.option} ${field.model} : false`);
                            formHasErrors = true;
                            validationErrors.push(`${familyOption.option} ${field.label} is required.`);
                        } 
                    }) 
                }                                            
                
            })

            if(!atLeastOneParentVisible){
                formHasErrors = true;
                validationErrors.push('Select a Parent/ Guardian.');
            }
            else{
                this.otherFields.forEach(field => {
                    if(field.required && !this.studentRecord[field.model]){
                        console.log(`${field.model} : false`);
                        formHasErrors = true;
                        if(field.category == 'emergency_contact'){
                            validationErrors.push(`Emergency Contact ${field.label} is required.`);
                        }
                        else validationErrors.push(`${field.label} is required.`);
                    }
                })
            }
            

            if(!formHasErrors) this.setFamilyDataValidated(true);
            else this.setFamilyDataValidated(false);

            this.setValidationErrors(validationErrors);                  
        },

        validateOtherData(){
            console.log('Validating...');            
            let validationErrors = [];
            let formHasErrors = false;

            console.log(this.otherDataFields);

            let fields = this.otherDataFields;
            
            fields.forEach(field => {
                console.log(field);
                if(field.required && !this.studentRecord[field.model]) {                    
                    console.log(`${field.model} : false`);
                    formHasErrors = true;
                    validationErrors.push(`${field.label} is required.`);
                }                                           
                
            })            

            if(!formHasErrors) this.setOtherDataValidated(true);
            else this.setOtherDataValidated(false);

            this.setValidationErrors(validationErrors);            
        },
        
        displayValidationErrors(){
            this.setDialog(true);
            this.setDialogTextColor('red--text');
            this.setDialogTitle('Section Incomplete');
            this.setDialogCard(true);
            this.setDialogProgress(false);
            this.setDialogText('Please review the following to proceed.')
        },

        submit(){
            console.log('submitted');
        }
    }
}
</script>